import { DateTime } from "luxon";
import { convertIsoDateToLuxon, convertMonthStringToInteger, set_time_to_midnight } from "../dateTimeFormatter";
import { getTimeZoneFromSwaStation } from "../timeZoneService";
import { getFirstDayWithMonthOffset, isHoliday } from "./timeOffBidUtils";
import { getThanksGivingDateOfTheYear } from "../dateHelper";

const isValidFTOBalance = (value) => {
  return /^(10|[0-9])$/.test(value) && Number(value) >= 0 && Number(value) <= 10;
};

export const getEligibleEmployeesWithInvalidBalances = (employees) => {
  return employees.filter(
    (employee) => employee.isEligible && !employee.isRemoved && !isValidFTOBalance(employee.balance)
  );
};

export const getDefaultCalendarMonth = (station, schedMonth, schedYear) => {
  const minDate = DateTime.max(
    set_time_to_midnight(DateTime.now().setZone(getTimeZoneFromSwaStation(station))),
    getFirstDayWithMonthOffset(
      schedMonth,
      schedYear,
      process.env.REACT_APP_IAM_FTO_ALLOWED_BID_WINDOW_MONTHS_RANGE_PRIOR_TO_BID_EFFECTIVE_MONTH
    )
  );

  return minDate.toJSDate();
};

export const getMinimumAllotmentValue = (schedMonth, schedYear, date, calcDailyAllotment) => {
  const month = convertMonthStringToInteger(schedMonth);
  const year = parseInt(schedYear);
  const thanksgivingDate = getThanksGivingDateOfTheYear(year);
  const luxonDate = convertIsoDateToLuxon(date);
  if ((month === 11 || month === 12) && isHoliday(luxonDate, year, thanksgivingDate)) {
    return 0;
  }
  return calcDailyAllotment.amOrPmCount;
};
